export default __webpack_public_path__ + "static/media/logo-white-flag.682fd8f9.png";